window.VegasCakeConstructor = {
	container: '.vg-constructor',
	wrapper: '.vg-constructor-wrapper',
	result: '.vg-constructor-result',
	item: '.item',
	form: 'form-constructor',
	formData: new FormData(),
	required_fields: ['user_name', 'user_phone', 'user_email', 'user_date'],

	init: function () {
		let $firstType = $(VegasCakeConstructor.container).find('[name="type"]:checked');
		this.toggleType($firstType);
	},

	cntCheckbox: function (self) {
		let $container = $(self).closest(VegasCakeConstructor.item),
			cnt = $container.data('cnt');

		if ($container.find('input:checked').length === cnt) {
			$container.find('input:not(:checked)').filter(function () {
				return $(this).attr('disabled', true);
			});
		} else if ($container.find('input:checked').length === 0) {
			$container.find('input').each(function () {
				this.disabled = false;
			});

			self.checked = true;
		} else {
			$container.find('input').each(function () {
				$(this).attr('disabled', false)
			});
		}
	},

	toggleType: function ($self) {
		let target = $self.val();

		$(VegasCakeConstructor.container).find('[data-type]').addClass('d-none');
		$(VegasCakeConstructor.container).find('[data-type]').find('input').each(function () {
			if (this.checked) {
				this.checked = false;
			}

			if (this.disabled) {
				this.disabled = false;
			}
		});

		$(VegasCakeConstructor.container).find('input[name=type]:checked').each(function () {
			let price = $(this).closest('.item-label').data('price');

			$(this).closest('.item').find('.item-title span b').text(price);
		});

		$(VegasCakeConstructor.container).find('[data-type="'+ target +'"]').removeClass('d-none');
		$(VegasCakeConstructor.container).find('[data-type="'+ target +'"]').find('input.sub-type').each(function (i) {
			if (i === 0) {
				this.checked = true;
			}
		});
		$(VegasCakeConstructor.container).find('[data-type="'+ target +'"]').find('input.filler').each(function (i) {
			if (i === 0) {
				this.checked = true;
			}
		});
	},

	collect: function () {
		let field = {
				type: {
					'Бисквитный': 'Бисквитный торт',
					'Муссовый': 'Муссовый торт',
					'Свадебный': 'Свадебный торт'
				},
				sub_type: {
					title: 'Основа',
					order: 0,
					multiple: 'subTypes'
				},
				filler_biscuit: {
					title: 'Крем',
					order: 1
				},
				filler_mousse: {
					title: 'Наполнитель для мусса',
					order: 1
				},
				filler_wedding: {
					title: '',
					order: 1
				},
				stage: {
					title: 'Количество ярусов',
					order: 2
				},
				finishing: {
					title: 'Отделка',
					order: 3,
					multiple: 'finishing'
				},
				decoration: {
					title: 'Декоративные элементы',
					order: 4,
					multiple: 'decoration'
				},
				cake_text: {
					title: 'Надпись на торте',
					order: 5
				},
				cake_wish: {
					title: 'Пожелания',
					order: 6
				},
				attachments: {
					title: 'Вложения',
					order: 7,
					multiple: 'attachments'
				}
			},
			attachments = [],
			decoration = [],
			finishing = [],
			subTypes = [];

		this.formData = new FormData(document.getElementById(VegasCakeConstructor.form))

		/**
		 * Упорядочиваем массивные данные
		 */
		for(let [name, value] of this.formData) {
			if (name === 'type') {
				this.formData.set(name, field.type[value]);
			}

			if (name === 'sub_type_biscuit' || name === 'sub_type_mousse' || name === 'sub_type_wedding') {
				subTypes.push(value);
			}

			if (name === 'decoration') {
				decoration.push(value);
			}

			if (name === 'finishing') {
				finishing.push(value);
			}

			if (name === 'files[]' && value.name.length) {
				attachments.push(value);
			}
		}

		// base
		this.formData.delete('sub_type_biscuit');
		this.formData.delete('sub_type_mousse');
		this.formData.delete('sub_type_wedding');
		this.formData.append('sub_type', subTypes.join(', '));

		// decoration
		this.formData.delete('decoration');
		this.formData.append('decoration', decoration.join(', '));

		// finishing
		this.formData.delete('finishing');
		this.formData.append('finishing', finishing.join(', '));

		/**
		 * Выводим данные по конструкторы
		 */

		// открываем поле с результатом
		$(VegasCakeConstructor.container).find(VegasCakeConstructor.result).addClass('show');
		document.getElementById('constructor').scrollIntoView();

		for(let [name, value] of this.formData) {
			let div = document.createElement('div'),
				$title = document.createElement('h4'),
				$text = document.createElement('p');

			if (typeof name === 'string' && value.length) {
				if (name === 'type') {
					$(VegasCakeConstructor.result).find('.title-area').text(value);
				} else {
					if (field[name]) {
						$title.innerText = field[name].title;

						if (field[name].multiple) {
							let array = [];

							switch (field[name].multiple) {
								case 'subTypes':
									array = subTypes;
									break;
								case 'decoration':
									array = decoration;
									break;
								case 'finishing':
									array = finishing;
									break;
							}

							for (let sub of array) {
								let $span = document.createElement('span');
								$span.innerHTML = sub;
								$text.appendChild($span)
							}
						} else {
							$text.innerHTML = '<span>'+ value +'</span>';
						}

						VegasCakeConstructor.appendDiv(div, $title, $text, field[name].order);
					}
				}
			}
		}

		/**
		 * Файлы
		 */
		if (attachments.length) {
			let div = document.createElement('div'),
				$title = document.createElement('h4'),
				$text = document.createElement('p');

			$title.innerText = field.attachments.title;
			$text.innerHTML = '<span>Файлов: ' + attachments.length + '</span>';
			VegasCakeConstructor.appendDiv(div, $title, $text, field.attachments.order);
		}
	},

	send: function (callback) {
		let $form = $('#' + this.form);

		$form.find('.form-group').each(function () {
			$(this).removeClass('required');
		});

		this.required_fields.forEach(function (element) {
			VegasCakeConstructor.formData.delete(element);
		});

		let emptyFields = [];

		if (this.required_fields.length) {
			this.required_fields.forEach(function (element) {
				let value = $form.find('input[name="' + element + '"]').val();

				if (value) {
					if (element === 'user_email') {
						const validateEmail = (value) => {
							return String(value)
							.toLowerCase()
							.match(
								/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
							);
						};

						if (!validateEmail(value)) {
							emptyFields.push(element);
						} else {
							VegasCakeConstructor.formData.append(element, value)
						}
					} else {
						VegasCakeConstructor.formData.append(element, value)
					}
				} else {
					emptyFields.push(element);
				}
			});
		}

		if (emptyFields.length) {
			for (let i = 1; i <= emptyFields.length; i++) {
				let $input = $form.find('input[name="' + emptyFields[i - 1] +'"]');

				if ($input) {
					if (i === 1) {
						$input.focus();
					}

					$input.closest('.form-group').addClass('required');
				}
			}
		} else {
			this.post(callback);
		}
	},

	post: function (callback) {
		let $form = $('#' + this.form);

		$.ajax({
			url: $form.attr('action'),
			method: 'post',
			data: this.formData,
			cache: false,
			contentType: false,
			processData: false,
			beforeSend: function () {
				if (typeof callback.before === 'function') callback.before();
			},
			success: function (data) {
				if (typeof callback.success === 'function') callback.success(data);
			},
			error: function (jqXHR) {
				let json = JSON.parse(jqXHR.responseText);
				let msg;

				if (json.errors) {
					msg = json.errors[Object.keys(json.errors)[0]][0];
				} else {
					msg = json.message || json.msg;
				}

				if (typeof callback.error === 'function') callback.error(msg);
			}
		});
	},

	appendDiv: function (div, $title, $text, order) {
		div.appendChild($title)
		div.appendChild($text);

		div.classList.add('content-area--item');
		div.classList.add('order-' + order);
		$(VegasCakeConstructor.result).find('.content-area').prepend(div);
	}
}

$(document).ready(function () {
	if ($(VegasCakeConstructor.container).length) {
		VegasCakeConstructor.init();
	}

	$('[data-toggle="cake-box"]').change(function () {
		VegasCakeConstructor.cntCheckbox(this);

		return false;
	});

	$('[data-toggle="cake-type"]').change(function () {
		VegasCakeConstructor.toggleType($(this));

		return false;
	});

	$('[data-toggle="cake-collect"]').click(function () {
		VegasCakeConstructor.collect();

		return false;
	});

	$('#btnPrev').click(function () {
		$(VegasCakeConstructor.container).find(VegasCakeConstructor.result).removeClass('show');
		document.getElementById('constructor').scrollIntoView();

		VegasCakeConstructor.formData = new FormData();
		$(VegasCakeConstructor.result).find('.content-area').html('');

		return false;
	});

	$('#btnSendConstructor').click(function () {
		VegasCakeConstructor.send({
			before: function () {
				$('#btnSendConstructor').attr('disabled', true).text('Отправляем...');
				$('#btnPrev').attr('disabled', true);
				let $result = $('#result-constructor-wrapper');
				$result.slideUp();
			},
			success: function (data) {
				setTimeout(() => {
					let $result = $('#result-constructor-wrapper');
					$result.slideDown();

					/*let $user_wrap = $(VegasCakeConstructor.container).find('.user-area');
					$user_wrap.slideUp();*/

					$result.find('.alert').addClass('alert-success').html(data.msg);
					$('#btnSendConstructor').text('Отправить');
				}, 500)
			},
			error: function (message) {
				setTimeout(() => {
					let $result = $('#result-constructor-wrapper');
					$result.slideDown();
					$result.find('.alert').addClass('alert-danger').html(message);
					$('#btnSendConstructor').text('Отправить').attr('disabled', false);
				}, 500);
			}
		});
	});
});

